import script from "./DetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailPage.vue?vue&type=script&lang=ts&setup=true"

import "./DetailPage.vue?vue&type=style&index=0&id=17d68c89&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ljy\\Desktop\\workspace\\JIN-SOLUTIONS\\JMON_MES\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17d68c89"]])

export default __exports__